/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { AnyAction } from 'redux';
import { SET_CHANNEL_OPTIONS, SET_CHANNELS_TYPE } from './channeloptionsoverlay.types';

export const setChannelsTypeAction = (
    channelsType: string,
    channelsTypeIndex: string,
): AnyAction => ({
    type: SET_CHANNELS_TYPE,
    payload: {
        channelsType,
        channelsTypeIndex,
    },
});

export const setChannelOptionsAction = (
    channelsType: string,
    watchNowText: string,
    channelsText: string,
    horizontalSelectionOptions: string[],
): AnyAction => ({
    type: SET_CHANNEL_OPTIONS,
    payload: {
        channelsType,
        watchNowText,
        channelsText,
        horizontalSelectionOptions,
    },
});
